/**
 * Dashboard - Update a casting
 */

'use strict';

// Constructor
var FrontDashboardCastingForm = function () {
    var bodyClasses = $('body').attr('class').split(" ");
    var i = 0;
    var found = false;
    while (i < bodyClasses.length && !found) {
        if (bodyClasses[i].indexOf('dashboard-casting-edit-') == 0) { // starts with
            found = true;
        }
        i++;
    }

    if (found == false) {
        return;
    }

    var self = this;

    $(document).ready((function () {
        this.idCasting = parseInt($('#idPostEdited').val());

        this.init();
        this.initFormFields();
        this.submitForm();
        this.addNewRole();
        this.editRole();
        this.deleteRole();
        this.selectRole();
        this.deleteActorFromCasting();
        this.shareButtons();

        setTimeout(function() {
            self.gridActors();
            self.filterActorsByRole();
            self.displayActorInfosHover();
            self.searchOrAddActor();
            self.setActorRoles();
            self.finalRole();
            self.viewListVideos();
            self.playVideo();
            self.addVideo();
        }, this.loadingTimeout);
    }).bind(this));
};

FrontDashboardCastingForm.prototype = {
    idCasting: 0,
    lockAjaxForm: false,
    lockAjaxGetRole: false,
    lockAjaxDeleteActor: false,
    lockAjaxDeleteRole: false,
    lockAjaxUpdateGrid: false,
    lockAjaxSetActorRoles: false,
    lockAjaxGetActorRoles: false,
    lockAjaxFinalRole: false,
    loadingTimeout: 2000, // ms
    idRoleFinal: '00000000000000000000000000000000',

    /**
     * Initialize the UI components.
     */
    init: function() {
        var self = this;

        setTimeout(function() {
            // Wait for AJAX requests and other stuff...
            $('.section-actions').css('opacity', 1);
            $('#edit-wait').hide();
            $('#casting-form').fadeIn();
            $('.fake-submit').removeClass('disabled');
            self.updateContainerHeight();
        }, self.loadingTimeout);
    },

    /**
     * Initialize date picker(s).
     */
    initFormFields: function() {
        // Start date
        var monthsFull = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        var weekdaysFull = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
        var weekdaysShort = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];
        var weekdaysLetter = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];

        $('#infos #date-start').datepicker({
            container: '#site-header',
            format: 'dd.mm.yyyy',
            minDate: new Date(),
            defaultDate: new Date(),
            firstDay: 1,
            showClearBtn: true,
            i18n: {
                cancel: null,
                clear: comedien.i18n.pickadateClear,
                done: comedien.i18n.pickadateClose,
                weekdaysShort: weekdaysShort,
                weekdaysLetter: weekdaysLetter,
                weekdays:weekdaysFull,
                months: monthsFull
            },
            onClose: function () {
                var value = this.date;
                var day = value.getDate();
                var monthIndex = value.getMonth()+1;
                var year = value.getFullYear();

                if (monthIndex < 10) {
                    monthIndex = '0'+monthIndex;
                }
                if (value !== '') {
                    var datetime = year + '-' + monthIndex + '-' + day;
                    if (datetime.length >= 9) {
                        $('#infos #date-start-dt').val(datetime);
                        $('#infos #date-start').removeClass('force-invalid').addClass('force-valid');
                    } else {
                        $('#infos #date-start-dt').val('');
                        $('#infos #date-start').removeClass('force-valid');
                    }
                    $('infos label[for="date-start"]').addClass('active');
                } else {
                    $('#infos #date-start-dt').val('');
                    $('#infos #date-start').removeClass('force-valid');
                }
                $('#infos #date-start').blur();
            }
        });


        if ($('#date-start').val() != '') {

            var date = $('#date-start').val().split("-");
            var day = date[2];
            var monthIndex = date[1];
            var year = date[0];
            var datetime = day + '.' + monthIndex + '.' + year;

            $('#infos #date-start').val(datetime)

            var currentDate = new Date(year, monthIndex-1, day);
            $('#infos #date-start').datepicker('setDate',  currentDate);
        }

        // TinyMCE
        tinymce.init({
            selector: '.tinymce',
            language: 'fr_FR',
            plugins: 'lists advlist paste link',
            toolbar: 'undo redo | bold italic | bullist numlist | link unlink | removeformat paste',
            menubar: false,
            branding: false,
            paste_data_images: false,
            paste_as_text: true,
            setup: function (editor) {
                editor.on('init', function (e) {
                    // Update height of columns
                    $('main#content > .col').matchHeight();
                });
            }
        });
    },


    /**
     * Submit the form to update the casting.
     */
    submitForm: function() {
        var self = this;
        var form = $('#casting-form');
        var btnSubmit = $('.section-actions .fake-submit');
        var spinner = $('.section-actions .preloader-wrapper');

        form.submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            btnSubmit.addClass('disabled');
            spinner.css('display', 'inline-block').css('opacity', 1);
            $('.invalid', form).removeClass('invalid');

            var ajaxAction = 'dashboard.casting.update';

            // Get HTML content from TinyMCE
            var description = tinymce.get('description').getContent();

            var formdata = false;
            if (window.FormData){
                formdata = new FormData(form[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
                formdata.append('description', description);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: formdata ? formdata : form.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security + "&description=" + description,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function(response) {
                if (response.success) {
                    $('.invalid', form).removeClass('invalid');
                    M.toast({html:'<span>'+ comedien.i18n.castingSaved +'</span>'}, 5000);
                } else {
                    var nbErrors = Object.keys(response.data.errors).length;
                    if (nbErrors > 0) {
                        $.each(response.data.errors, function (i, item) {
                            $('#' + i, form).addClass('invalid');
                            M.toast({html:'<span>'+item +'</span>'}, 5000);
                        });
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }
                }

                btnSubmit.removeClass('disabled');
                self.lockAjaxForm = false;
                spinner.css('opacity', 0).css('display', 'none');
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;
                btnSubmit.removeClass('disabled');
                spinner.css('opacity', 0).css('display', 'none');
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });

        btnSubmit.on('click', function() {
            var result = self.validateFormBeforeSubmit();

            if (result) {
                $('#casting-form').submit();
            }
        });
    },

    /**
     * Validate the form before submit it.
     *
     * @returns {boolean}
     */
    validateFormBeforeSubmit: function() {
        return true;
    },

    /**
     * Create/add a new role for this casting.
     */
    addNewRole: function() {
        var self = this;
        var $modal = $('#modal-dashboard-casting-new-role');

        $modal.modal({
            dismissible: false,
        });

        $('section#roles #chips .add').on('click', function() {
            $modal.modal('open');
        });

        $('#modal-dashboard-casting-new-role .btn-confirm').on('click', function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            $('.preloader-wrapper', $modal).fadeIn();
            $('.content-before .btn-confirm', $modal).addClass('disabled');
            $('.content-before .modal-action', $modal).addClass('disabled');

            var ajaxAction = 'dashboard.casting.add_role';

            var name = $('#name', $modal).val();
            var description = $('#description', $modal).val();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: "action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&name=" + name + "&description=" + description,
            }).done(function(response) {
                if (response.success) {
                    // Add the new chip just before the last one
                    var chip = '<div class="chip" data-id="' + response.data.id + '" data-filter=".' + response.data.id + '">' + response.data.name + '</div>';
                    $(chip).insertBefore('section#roles #chips .final');

                    $('#name', $modal).val('');
                    $('#description', $modal).val('');

                    $('main#content > .col').matchHeight();
                    $('.preloader-wrapper', $modal).fadeOut();
                    $modal.modal('close');
                } else {
                    var nbErrors = Object.keys(response.data.errors).length;
                    if (nbErrors > 0) {
                        $.each(response.data.errors, function (i, item) {
                            $('#' + i, $modal).addClass('invalid');
                            M.toast({html:'<span>'+ item +'</span>'}, 5000);
                        });
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }
                }

                $('.content-before .btn-confirm', $modal).removeClass('disabled');
                $('.content-before .modal-action', $modal).removeClass('disabled');
                $('.preloader-wrapper', $modal).hide();

                self.lockAjaxForm = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    /**
     * Edit a role for this casting.
     */
    editRole: function() {
        var self = this;

        // Display the input fields to edit role data
        $('section#roles').on('click', '#infos-role .btn-edit', function(e) {
            e.preventDefault();

            $('#infos-role .btn-edit').hide();
            $('#infos-role .btn-delete').hide();
            $('#infos-role .btn-validate').css('display', 'inline-block');
            $('#infos-role .btn-cancel').css('display', 'inline-block');

            $('#infos-role .view').hide();
            $('#infos-role .edit').show();
            self.updateContainerHeight();
        });

        // Cancel editing (hide the input fields)
        $('section#roles').on('click', '#infos-role .btn-cancel', function(e) {
            e.preventDefault();

            $('#infos-role .btn-edit').css('display', 'inline-block');
            $('#infos-role .btn-delete').css('display', 'inline-block');
            $('#infos-role .btn-validate').hide();
            $('#infos-role .btn-cancel').hide();

            $('#infos-role .view').show();
            $('#infos-role .edit').hide();
            self.updateContainerHeight();
        });

        // Send form
        $('section#roles').on('click', '#infos-role .btn-validate', function(e) {
            e.preventDefault();

            var idRole = $('section#roles #chips .selected').attr('data-id');

            if (idRole == self.idRoleFinal) {
                return;
            }

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            $('#infos-role').hide();
            $('#infos-role-wait').slideDown();

            var ajaxAction = 'dashboard.casting.edit_role';
            var name = ($('#infos-role #roleName').val()).trim();
            var description = ($('#infos-role #roleDescription').val()).trim();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: "action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&idRole=" + idRole + "&name=" + name + "&description=" + description,
            }).done(function(response) {
                if (response.success) {
                    $('#infos-role .view .title').html(response.data.name);
                    $('#infos-role .view .txt').html(response.data.description);

                    $('#infos-role-wait').fadeOut(400, function() {
                        $('#infos-role .btn-edit').css('display', 'inline-block');
                        $('#infos-role .btn-delete').css('display', 'inline-block');
                        $('#infos-role .btn-validate').hide();
                        $('#infos-role .btn-cancel').hide();

                        $('#infos-role .view').show();
                        $('#infos-role .edit').hide();
                        $('#infos-role').show();

                        // Update the name of the chips
                        $('section#roles #chips .selected').text(name);

                        self.updateContainerHeight();
                    });
                } else {
                    if (response.data.errors) {
                        $.each(response.data.errors, function (i, item) {
                            if (i == 'name') {
                                $('#infos-role #roleName').addClass('invalid');
                            } else if (i == 'description') {
                                $('#infos-role #roleDescription').addClass('invalid');
                            }

                            M.toast({html:'<span>'+ item +'</span>'}, 5000);
                        });
                    }

                    $('#infos-role-wait').fadeOut(400, function() {
                        $('#infos-role').show();
                        self.updateContainerHeight();
                    });
                }

                self.lockAjaxForm = false;
                self.updateContainerHeight();
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);

                $('#infos-role-wait').fadeOut(400, function() {
                    $('#infos-role').show();
                    self.updateContainerHeight();
                });
            });
        });
    },

    /**
     * Delete/remove a role for this casting.
     */
    deleteRole: function() {
        var self = this;
        var $modal = $('#modal-delete-role');

        $modal.modal({
            dismissible: false,
        });

        $('section#roles').on('click', '#infos-role .btn-delete', function(e) {
            e.preventDefault();

            $modal.modal('open');
        });

        $('#modal-delete-role .btn-confirm').on('click', function(e) {
            e.preventDefault();

            if (self.lockAjaxDeleteRole) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxDeleteRole = true;

            $('.preloader-wrapper', $modal).fadeIn();
            $('.content-before .btn-confirm', $modal).addClass('disabled');
            $('.content-before .modal-action', $modal).addClass('disabled');

            var ajaxAction = 'dashboard.casting.delete_role';
            var idRole = $('section#roles #chips .selected').attr('data-id');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: "action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&idRole=" + idRole,
            }).done(function(response) {
                if (response.success) {
                    // Select the chip "all"
                    $('section#roles #chips .chip[data-id="' + idRole + '"]').remove();

                    // Update the items in the grid
                    self.updateGridActors({
                        showInfosRole: false
                    });

                    $('.preloader-wrapper', $modal).fadeOut();
                    $modal.modal('close');
                } else {
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }

                $('.content-before .btn-confirm', $modal).removeClass('disabled');
                $('.content-before .modal-action', $modal).removeClass('disabled');

                self.lockAjaxDeleteRole = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxDeleteRole = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    /**
     * Select a role and display its name, title and buttons to delete or edit it.
     */
    selectRole: function () {
        var self = this;

        $('section#roles #chips').on('click', '.chip', function(e) {
            e.preventDefault();

            var $theChips = $(this);
            var idRole = $(this).attr('data-id');

            $('section#roles #chips').find('.selected2').each(function() {
                $(this).removeClass('selected2'); // bug with with MaterializeCSS
            });

            if (idRole == self.idRoleFinal || idRole == 'all') {
                $('#infos-role').hide();
                $theChips.addClass('selected2'); // bug with with MaterializeCSS
                return;
            }

            if (self.lockAjaxGetRole) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxGetRole = true;

            $('#infos-role').hide();
            $('#infos-role-wait').slideDown();

            var ajaxAction = 'dashboard.casting.get_role';

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: "action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&idRole=" + idRole,
            }).done(function(response) {
                if (response.success) {
                    $('#infos-role .view .title').html(response.data.name);
                    $('#infos-role .view .txt').html(response.data.description);
                    $('#infos-role .edit #roleName').val(response.data.name);
                    $('#infos-role .edit #roleDescription').val(response.data.description);

                    $('#roles #infos-role-wait').fadeOut(400, function() {
                        $('#roles #infos-role').show();
                        self.updateContainerHeight();
                    });

                    $theChips.addClass('selected');
                } else {
                    $('#infos-role').hide();
                    $('#infos-role-wait').fadeOut(400);
                }

                self.updateContainerHeight();
                self.lockAjaxGetRole = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxGetRole = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
                $('#roles #infos-role-wait').fadeOut(400);
                self.updateContainerHeight();
            });
        });
    },

    /**
     * Display a grid of actors using Isotope.
     */
    gridActors: function() {
        // Init Isotope
        var $grid = $('#actors-role .items').isotope({
            itemSelector: '.item',
            percentPosition: true,
            masonry: {
                columnWidth: '.item-sizer',
            },
        });

        $grid.on('arrangeComplete', function (event, filteredItems) {
            $('main#content > .col').matchHeight();
        });
    },

    /**
     * Update the grid of actors by adding, removing or updating actors.
     *
     * @param {Object} options Keys:
     *  - (string) filter : md5 ID
     *  - (bool) showInfosRole
     */
    updateGridActors: function(options) {
        var self = this;

        if (self.lockAjaxUpdateGrid) {
            // Pending AJAX request... wait
            return;
        }

        self.lockAjaxUpdateGrid = true;

        $('#infos-role').hide();
        $('#infos-role-wait').slideDown();

        var ajaxAction = 'dashboard.casting.get_actors_for_grid';
        var $grid = $('#actors-role .items');

        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: "action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&html=true",
        }).done(function(response) {
            if (response.success) {
                // Remove items
                $grid.isotope('remove', $grid.find('.item'));
                $grid.isotope('destroy');

                // Insert new items and reload the grid
                $('#actors-role .items').html(response.data);
                self.gridActors();
                $grid.isotope({ filter: '*, .new' });
                self.displayActorInfosHover();

                // Chip selection

                var showInfosRole = true;
                if (options !== null && typeof options === 'object' && typeof options.showInfosRole !== 'undefined') {
                    if (options.showInfosRole == false) {
                        showInfosRole = false;
                    }
                }

                console.log('tes 3');
                $('section#roles #chips .chip.selected').removeClass('selected');

                if (options !== null && typeof options === 'object' && typeof options.filter !== 'undefined') {
                    // Select the given chip
                    $('section#roles #chips .chip[data-id="' + options.filter + '"]').addClass('selected').trigger('click');
                } else {
                    // Select the chip "all"
                    $('section#roles #chips .chip[data-id="all"]').addClass('selected').trigger('click');
                }

                $('#roles #infos-role-wait').fadeOut(400, function() {
                    if (showInfosRole) {
                        $('#roles #infos-role').show();
                    }
                    self.updateContainerHeight();
                });

                // Video view

                if (options !== null && typeof options === 'object' && typeof options.videoList !== 'undefined') {
                    if (options.videoList == true) {
                        $('section#roles .viewListVideos').trigger('click');
                    }
                }
            } else {
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);

                $('#infos-role').hide();
                $('#infos-role-wait').fadeOut(400);
            }

            self.lockAjaxUpdateGrid = false;
        }).fail(function(jqXHR, textStatus) {
            self.lockAjaxUpdateGrid = false;
           M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
            console.log("Request failed: " + textStatus);
            $('#infos-role-wait').fadeOut(400);
        });
    },

    /**
     * Filter the Isotope actor grid by role.
     */
    filterActorsByRole: function() {
        var self = this;
        var $grid = $('#actors-role .items');

        $('section#roles #chips').on('click', '.chip', function(e) {
            var idRole = $(this).data('filter');
            $grid.isotope({ filter: idRole +', .new' });

            // On final role, hide the "move to trash" icon
            if (idRole == '.' + self.idRoleFinal) {
                $('#actors-role .items .item .bottom .delete').hide();
            } else {
                $('#actors-role .items .item .bottom .delete').show();
            }
        });
    },

    displayActorInfosHover: function() {
        $('#actors-role .items .item').mouseenter(function() {
            $(this).find('.roles').hide();
            $(this).find('.video').hide();
            $(this).find('.hover').stop().fadeIn(400);

            if ($('section#roles .viewListVideos').hasClass('active')) {
                $(this).find('.inner-video').show();
            } else {
                $(this).find('.inner-video').hide();
            }
        }).mouseleave(function() {
            if ($('section#roles .viewListVideos').hasClass('active')) {
                $(this).find('.roles').hide();
                $(this).find('.video').show();
                $(this).find('.inner-video').show();
            } else {
                $(this).find('.roles').show();
                $(this).find('.video').hide();
                $(this).find('.inner-video').hide();
            }

            $(this).find('.hover').stop().fadeOut(400);
        });
    },

    /**
     * Delete an actor from the casting.
     */
    deleteActorFromCasting: function() {
        var self = this;
        var idActorToDelete = '';
        var $modal = $('#modal-delete-actor-from-casting');

        $modal.modal({
            dismissible: false,
        });

        $('#actors-role .items').on('click', '.item .delete', function() {
            var fullname = '';
            var firstname = $(this).parents('.item').find('.firstname').text();
            var lastname = $(this).parents('.item').find('.lastname').text();

            if (firstname != '' && lastname != '') {
                fullname = firstname + ' ' + lastname;
            } else if (firstname != '') {
                fullname = firstname;
            } else if (lastname != '') {
                fullname = lastname;
            }

            if (fullname != '') {
                $modal.find('.content-before .name').text(fullname);
            }

            idActorToDelete = $(this).parents('.item').data('id');

            $modal.modal('open');
        });

        $('.btn-confirm', $modal).on('click', function(e) {
            e.preventDefault();

            if (self.lockAjaxDeleteActor) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxDeleteActor = true;

            $('.preloader-wrapper', $modal).fadeIn();
            $('.content-before .btn-confirm', $modal).addClass('disabled');
            $('.content-before .modal-action', $modal).addClass('disabled');

            var ajaxAction = 'dashboard.casting.delete_actor';

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: "action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&idActor=" + idActorToDelete,
            }).done(function(response) {
                if (response.success) {
                    // Remove the actor from the Isotope grid
                    var item = $('#actors-role .items .item[data-id="' + idActorToDelete + '"]');
                    $('#actors-role .items').isotope('remove', item).isotope('layout');

                    $('main#content > .col').matchHeight();

                    $('.preloader-wrapper', $modal).fadeOut();

                    $modal.modal('close');
                } else {
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }

                $('.content-before .btn-confirm', $modal).removeClass('disabled');
                $('.content-before .modal-action', $modal).removeClass('disabled');

                self.lockAjaxDeleteActor = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxDeleteActor = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    /**
     * Add an actor to the casting.
     */
    searchOrAddActor: function() {
        var self = this;
        var $modal = $('#modal-dashboard-casting-add-actor');
        var $modalNewActor = $('#modal-dashboard-casting-add-new-actor');

        $modal.modal({
            dismissible: false,
        });

        $modalNewActor.modal({
            dismissible: false,
        });

        $('#actors-role .items').on('click', '.new a', function() {
            $modal.modal('open');

            // Initialize the select2 dropdown

            $('#actor-search', $modal).select2({
                placeholder: comedien.i18n.castingPlaceholderSearchActor,
                allowClear: false,
                ajax: {
                    url: comedien.ajaxurl,
                    type: 'POST',
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            action: 'dashboard.casting.search_actor',
                            security: comedien.security,
                            name: params.term,
                        };
                    },
                    processResults: function (selectData, params) {
                        return {
                            results: selectData.data,
                        };
                    },
                    cache: true
                },
                escapeMarkup: function (markup) { return markup; },
                templateResult: self.actorsDropdownTplResult,
                templateSelection: self.actorsDropdownTplSelection,
                'language': {
                    'noResults': function() {
                        return "<div id='actorNotFound'><p>Aucun comédien correspond à votre recherche.</p><a href='javascript:;' class='waves-effect waves-light btn btn-small z-depth-0 btn-add-actor-casting'><i class='material-icons left'>add</i>Créer un comédien</a></div>";
                    },
                    'inputTooShort': function(){
                        return "Taper au moins 2 caractères";
                    },
                    'searching': function() {
                        return comedien.i18n.select2Searching;
                    },
                    'errorLoading': function() {
                        return comedien.i18n.select2Searching;
                        //return comedien.i18n.select2ErrorLoading;
                    },
                },
            });
        });

        // Triggered whenever an actor is selected in the dropdown.
        $('#actor-search').on('select2:select', function (e) {
            var idActor = parseInt($(this).val());
            if (idActor > 0) {
                $('.content-before', $modal).hide();
                $('.content-after', $modal).show();
                $('.error', $modal).hide();

                if (self.lockAjaxForm) {
                    // Pending AJAX request... wait
                    return;
                }

                self.lockAjaxForm = true;

                var ajaxAction = 'dashboard.casting.add_existing_actor';

                $.ajax({
                    url: comedien.ajaxurl,
                    type: 'POST',
                    dataType: 'json',
                    data: "action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&idActor=" + idActor,
                }).done(function(response) {
                    if (response.success) {
                        // Update the items in the grid
                        self.updateGridActors({
                            showInfosRole: false
                        });

                        // Reset the modal window
                        $('#actor-search').val(null).trigger('change');
                        $('.content-before', $modal).show();
                        $('.content-after', $modal).hide();

                        $modal.modal('close');
                    } else {
                        var nbErrors = Object.keys(response.data.errors).length;
                        if (nbErrors > 0) {
                            var errorMsg = '';

                            $.each(response.data.errors, function (i, item) {
                                errorMsg += '<p>' + item + '</p>';
                                M.toast({html:'<span>'+ item +'</span>'}, 5000);
                            });

                            $('.error', $modal).html(errorMsg).show();
                        } else {
                           M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                        }

                        $('#actor-search').val(null).trigger('change');
                        $('.content-before', $modal).show();
                        $('.content-after', $modal).hide();
                    }

                    self.lockAjaxForm = false;
                }).fail(function(jqXHR, textStatus) {
                    self.lockAjaxForm = false;
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    console.log("Request failed: " + textStatus);
                });
            }
        });

        // The new actor button is displayed only when the dropdown returns no results.
        $('body').on('click', '.btn-add-actor-casting', function() {
            $modal.modal('close');

            // Populate the role dropdown

            var hasRoles = false;

            $('section#roles #chips .chip:not(.final)').each(function() {
                var id = $(this).attr('data-id');
                if (id.length == 32) {
                    hasRoles = true;
                }
            });

            if (hasRoles) {
                $('#role', $modalNewActor).find("option:gt(0)").remove();

                $('section#roles #chips .chip:not(.final)').each(function() {
                    var id = $(this).attr('data-id');
                    if (id.length == 32) {
                        var option = new Option($(this).text().trim(), id);
                        $('#role', $modalNewActor).append($(option));
                    }
                });

                $('#row-add-to-role', $modalNewActor).show();
            } else {
                $('#role', $modalNewActor).find("option:gt(0)").remove();
                $('#row-add-to-role', $modalNewActor).hide();
            }

            $modalNewActor.modal('open');

            $('#role', $modalNewActor).val('');
            $('#role', $modalNewActor).formSelect('destroy');
            $('#role', $modalNewActor).formSelect();
        });

        $('.btn-confirm', $modalNewActor).on('click', function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            $('.preloader-wrapper', $modal).fadeIn();
            $('.content-before .btn-confirm', $modal).addClass('disabled');
            $('.content-before .modal-action', $modal).addClass('disabled');

            var form = $('form', $modalNewActor);

            var ajaxAction = 'dashboard.casting.add_new_actor';

            var formdata = false;
            if (window.FormData){
                formdata = new FormData(form[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
                formdata.append('idCasting', self.idCasting);
            }

            var dataSerialized = form.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting;

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: formdata ? formdata : dataSerialized,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function(response) {
                if (response.success) {
                    // Update the items in the grid
                    self.updateGridActors(null);

                    // Reset the modal window
                    $('.content-before .btn-confirm', $modal).removeClass('disabled');
                    $('.content-before .modal-action', $modal).removeClass('disabled');
                    $(form).find('input[type=text], input[type=number], input[type=file]').val('');

                    $modalNewActor.modal('close');
                } else {
                    var nbErrors = Object.keys(response.data.errors).length;
                    if (nbErrors > 0) {
                        $.each(response.data.errors, function (i, item) {
                            $('#' + i, form).addClass('invalid');
                            M.toast({html:'<span>'+ item +'</span>'}, 5000);
                        });
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }
                }

                $('.content-before .btn-confirm', $modal).removeClass('disabled');
                $('.content-before .modal-action', $modal).removeClass('disabled');

                self.lockAjaxForm = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    /**
     * Select2 template for displaying search results (for actors).
     * (for subjects)
     *
     * @param actor
     * @returns {string}
     */
    actorsDropdownTplResult: function(actor) {
        if (actor.loading) {
            return actor.text;
        }

        var markup = "<div class='actor'><span class='name'>" + actor.name + "</span></div>";

        return markup;
    },

    /**
     * Select2 template for displaying the selected result (for actors).
     *
     * @param actor
     * @returns {string}
     */
    actorsDropdownTplSelection: function(actor) {
        var output = '';

        if (actor.text) {
            output = actor.text;
        } else {
            output = "<span class='name'>" + actor.name + "</span>";
        }

        return output;
    },

    /**
     * Add or remove role(s) for a given actor.
     */
    setActorRoles: function() {
        var self = this;
        var idActor = '';
        var $modal = $('#modal-set-actor-roles');

        $modal.modal({
            dismissible: false,
        });

        $('#actors-role .items').on('click', '.item .setRoles', function() {
            if (self.lockAjaxGetActorRoles) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxGetActorRoles = true;

            // Name

            var fullname = '';
            var firstname = $(this).parents('.item').find('.firstname').text();
            var lastname = $(this).parents('.item').find('.lastname').text();

            if (firstname != '' && lastname != '') {
                fullname = firstname + ' ' + lastname;
            } else if (firstname != '') {
                fullname = firstname;
            } else if (lastname != '') {
                fullname = lastname;
            }

            if (fullname != '') {
                $modal.find('.content-before .name').text(fullname);
            }

            // List casting roles

            var htmlRoles = '';

            $('section#roles #chips .chip:not(.final)').each(function() {
                var id = $(this).attr('data-id');
                if (id.length == 32) {
                    htmlRoles += '<div class="col s6"><p><label for="role-' + id + '"><input type="checkbox" name="roles[]" id="role-' + id + '" value="' + id + '" /><span>' + $(this).text() + '</span></label></p></div>';
                }
            });

            $('.row-roles').html(htmlRoles);

            idActor = $(this).parents('.item').data('id');

            // Get actor's roles

            $modal.modal('open');

            $('.content-before .btn-confirm', $modal).addClass('disabled');
            $('.preloader-wrapper', $modal).fadeIn();
            $('.row-roles', $modal).hide();
            $('.row-roles', $modal).hide();

            var ajaxAction = 'dashboard.casting.get_actor_roles';

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: "action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&idActor=" + idActor,
            }).done(function(response) {
                if (response.success) {
                    $.each(response.data, function (i, item) {
                        var role = $modal.find('.content-before .row-roles #role-' + item);
                        role.attr('checked', true);
                    });
                } else {
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    $modal.modal('close');
                }

                $('.content-before .btn-confirm', $modal).removeClass('disabled');
                $('.preloader-wrapper', $modal).hide();
                $('.row-roles', $modal).fadeIn();

                self.lockAjaxGetActorRoles = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxGetActorRoles = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });

        $('.btn-confirm', $modal).on('click', function(e) {
            e.preventDefault();

            if (self.lockAjaxSetActorRoles) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxSetActorRoles = true;

            var form = $('form', $modal);

            $('.preloader-wrapper', $modal).fadeIn();
            $('.content-before .btn-confirm', $modal).addClass('disabled');
            $('.content-before .modal-action', $modal).addClass('disabled');

            var ajaxAction = 'dashboard.casting.set_actor_roles';

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: form.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&idActor=" + idActor,
            }).done(function(response) {
                if (response.success) {
                    // Update the items in the grid
                    self.updateGridActors({
                        showInfosRole: false
                    });

                    $('.preloader-wrapper', $modal).fadeOut();

                    $modal.modal('close');
                } else {
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }

                $('.content-before .btn-confirm', $modal).removeClass('disabled');
                $('.content-before .modal-action', $modal).removeClass('disabled');

                self.lockAjaxSetActorRoles = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxSetActorRoles = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    /**
     * Add or remove the actor from the final role.
     */
    finalRole: function() {
        var self = this;

        var makeRequest = function($element, action) {
            if (self.lockAjaxFinalRole) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxFinalRole = true;

            $element.css('cursor', 'wait');
            $('.material-icons', $element).css('opacity', '0.5');

            var ajaxAction = 'dashboard.casting.add_or_remove_final_role';
            var idActor = $element.parents('.item').data('id');
            var idRole = $element.parents('.item').data('role');

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: "action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&idActor=" + idActor + "&idRole=" + idRole + "&do=" + action,
            }).done(function(response) {
                $element.css('cursor', 'pointer');
                $('.material-icons', $element).css('opacity', '1');

                if (response.success) {
                    $('.toastLoading').fadeOut(500, function() {
                        $('.toastLoading').remove();
                    });

                    // Update the items in the grid
                    self.updateGridActors({
                        filter: self.idRoleFinal,
                        showInfosRole: false
                    });
                } else {
                    $('.toastLoading').remove();
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }

                self.lockAjaxFinalRole = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxFinalRole = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        };

        // Add the actor to the final role
        $('#actors-role .items').on('click', '.item .addFinal', function() {
            makeRequest($(this), 'add');
        });

        // Remove the actor to the final role
        $('#actors-role .items').on('click', '.item .removeFinal', function() {
            makeRequest($(this), 'remove');
        });
    },

    /**
     * Hide or show video icons.
     */
    viewListVideos: function() {
        // View list (w/o videos)
        $('section#roles .viewList').on('click', function() {
            $('section#roles .viewListVideos').removeClass('active');
            $(this).addClass('active');

            $('#actors-role .items .item .roles').show();
            $('#actors-role .items .item .video').hide();
        });

        // View list (with video)
        $('section#roles .viewListVideos').on('click', function() {
            $('section#roles .viewList').removeClass('active');
            $(this).addClass('active');

            $('#actors-role .items .item .roles').hide();
            $('#actors-role .items .item .video').show();
        });
    },

    /**
     * Play or delete the actor's video.
     */
    playVideo: function() {
        var self = this;
        var $modal = $('#modal-play-video');
        var idActor = 0;

        $modal.modal({
            dismissible: true,
            endingTop: '50%',
            ready: function(modal) {
                modal.css('transform', 'translateY(-50%)');
            },
            complete: function() {
                $('.video-container iframe', $modal).attr('src', '');
            },
        });

        // Show modal window to play the video
        $('#actors-role .items').on('click', '.item .playVideo', function() {
            var url = $(this).attr('data-url');
            idActor = $(this).parents('.item').data('id');

            if (url.length > 0) {
                var iframeSrc = url;
                if (url.indexOf('uploading-to-youtube') != -1) {
                    iframeSrc = '';
                }

                $('.video-container iframe', $modal).attr('src', iframeSrc);
                $modal.modal('open');

                if (url.indexOf('uploading-to-youtube') != -1) {
                    alert(comedien.i18n.castingVideoUploadingYt);
                }
            }
        });

        // Delete the video
        $('.delete', $modal).on('click', function(e) {
            e.preventDefault();

            if (confirm(comedien.i18n.castingConfirmVideoDelete)) {
                if (self.lockAjaxForm) {
                    // Pending AJAX request... wait
                    return;
                }

                self.lockAjaxForm = true;

                $('.preloader', $modal).css('opacity', 1);
                $('.buttons .delete', $modal).addClass('disabled');
                $('.buttons .modal-close', $modal).addClass('disabled');

                var ajaxAction = 'dashboard.casting.delete_actor_video';

                $.ajax({
                    url: comedien.ajaxurl,
                    type: 'POST',
                    dataType: 'json',
                    data: "action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&idActor=" + idActor,
                }).done(function(response) {
                    if (response.success) {
                        // Update the items in the grid
                        self.updateGridActors({
                            showInfosRole: false,
                            videoList: true,
                        });

                        // Reset the modal window
                        $('.preloader', $modal).css('opacity', 1);
                        $('.buttons .delete', $modal).removeClass('disabled');
                        $('.buttons .modal-close', $modal).removeClass('disabled');

                        $modal.modal('close');
                    } else {
                        $('.preloader', $modal).css('opacity', 0);
                        $('.buttons .delete', $modal).removeClass('disabled');
                        $('.buttons .modal-close', $modal).removeClass('disabled');
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }

                    self.lockAjaxForm = false;
                }).fail(function(jqXHR, textStatus) {
                    self.lockAjaxForm = false;
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    console.log("Request failed: " + textStatus);
                    $modal.modal('close');
                });
            }
        });
    },

    /**
     * Attach a video to an actor.
     */
    addVideo: function() {
        var self = this;
        var $modal = $('#modal-add-video');
        var $modalUpload = $('#modal-add-video-youtube');
        var idActor = 0;

        $modal.modal({
            dismissible: true,
        });

        $modalUpload.modal({
            dismissible: false,
        });

        // Show modal window to attach a new video
        $('#actors-role .items').on('click', '.item .addVideo', function() {
            idActor = $(this).parents('.item').data('id');
            $modal.modal('open');
        });

        $('.btn-confirm', $modal).on('click', function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            $('.preloader-wrapper', $modal).fadeIn();
            $('.content-before .btn-confirm', $modal).addClass('disabled');
            $('.content-before .modal-action', $modal).addClass('disabled');

            var form = $('form', $modal);
            var ajaxAction = 'dashboard.casting.set_actor_video';

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: form.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&idActor=" + idActor,
            }).done(function(response) {
                if (response.success) {
                    // Update the items in the grid
                    self.updateGridActors({
                        showInfosRole: false,
                        videoList: false,
                    });

                    // Reset the modal window
                    $('.content-before .btn-confirm', $modal).removeClass('disabled');
                    $('.content-before .modal-action', $modal).removeClass('disabled');
                    $(form).find('input[type=text], input[type=number], input[type=file]').val('');

                    $modal.modal('close');
                    M.toast({html: '<span>'+comedien.i18n.castingAddVideoSuccess+'</span>'}, 5000);
                } else {
                    $('#url', form).addClass('invalid');
                    M.toast({html: '<span>'+comedien.i18n.castingAddVideoError+'</span>'}, 5000);
                }

                $('.content-before .btn-confirm', $modal).removeClass('disabled');
                $('.content-before .modal-action', $modal).removeClass('disabled');

                self.lockAjaxForm = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });

        $('.btn-upload-video', $modal).on('click', function() {
            $modal.modal('close');
            $modalUpload.modal('open');
            upload();
        });

        var upload = function() {
            $('.progres-wrapper', $modalUpload).hide();
            $('.btn-confirm', $modalUpload).addClass('disabled');

            $('#fileupload', $modalUpload).fileupload({
                url: comedien.ajaxurl,
                dataType: 'json',
                formData: {
                    action: 'dashboard.casting.upload_video',
                    security: comedien.security,
                    idCasting: self.idCasting,
                    idActor: idActor
                },
                dropZone: null,
                disableVideoPreview: true,
                maxNumberOfFiles: 1,
                minFileSize: 1000000, // 1 Mb
                autoUpload: false,
                add: function (e, data) {
                    $.each(data.files, function (index, file) {
                        $('.file-path', $modalUpload).attr('placeholder', file.name);
                    });

                    $('.btn-confirm', $modalUpload).removeClass('disabled');

                    $('.btn-confirm', $modalUpload).off('click').on('click', function () {
                        data.submit();
                    });
                },
                // Callback for the start of each file upload request
                send: function (e, data) {
                    if (data.files.length > 1) {
                        return false;
                    }

                    $('.progres-wrapper', $modalUpload).fadeIn();
                    $('.btn-confirm', $modalUpload).addClass('disabled');
                },
                // Callback for successful upload requests
                done: function (e, data) {
                    $('.progress .determinate', $modalUpload).css('width', '95%');

                    if (data.result.success) {
                        setTimeout(function() {
                            $('.progress .determinate', $modalUpload).css('width', '100%');
                            $('.progres-wrapper', $modalUpload).fadeOut();

                            // Update the items in the grid
                            self.updateGridActors({
                                showInfosRole: false,
                                videoList: true,
                            });

                            // Reset the modal window
                            $('#fileupload', $modalUpload).val('');
                            $('.file-path', $modalUpload).attr('placeholder', comedien.i18n.castingVideoBrowse);

                            $modalUpload.modal('close');
                            M.toast({html: '<span>'+comedien.i18n.castingVideoUploadedSuccess+'</span>'}, 5000);
                        }, 10000);
                    } else {
                        setTimeout(function() {
                            $('.progres-wrapper', $modalUpload).fadeOut();
                        }, 1000);

                        $modal.modal('close');
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }
                },
                // Callback for failed (abort or error) upload requests
                fail: function(e, data) {
                    $('.progres-wrapper', $modalUpload).fadeOut();
                    $('.btn-confirm', $modalUpload).removeClass('disabled');
                    
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                },
                progressall: function (e, data) {
                    var progress = parseInt(data.loaded / data.total * 90, 10);
                    $('.progress .determinate', $modalUpload).css('width', progress + '%');
                }
            }).prop('disabled', !$.support.fileInput).parent().addClass($.support.fileInput ? undefined : 'disabled');
        };
    },

    shareButtons: function() {
        var self = this;
        var $modalShare = $('#modal-share-casting');
        var $modalEmail = $('#modal-send-casting-email');
        var $selectRole = $('#share-role', $modalShare);
        var type = '';

        function showModal() {
            // Dynamically populate the select dropdown with the roles

            var roles = [];

            $('section#roles #chips .chip').each(function() {
                var id = $(this).attr('data-id');
                if (id.length == 32) {
                    var text = ($(this).text()).trim();
                    if (id == self.idRoleFinal) {
                        text = 'CAST-IN final';
                    }

                    roles.push({
                        value: id,
                        text : text
                    });
                }
            });

            $selectRole.find('option').remove();

            $selectRole.append($('<option>', {
                value: '',
                text : 'Sélectionner un rôle'
            }));

            $.each(roles, function (i, item) {
                $selectRole.append($('<option>', {
                    value: item.value,
                    text : item.text
                }));
            });

            $selectRole.formSelect('destroy');
            $selectRole.formSelect();

            // Custom inputs (depending on the share type: email, pdf, print)

            if (type == 'email') {
                $('.input-field-email', $modalShare).show();
                $('.input-field-email', $modalShare).find('input').prop('required', true);
            } else {
                $('.input-field-email', $modalShare).hide();
                $('.input-field-email', $modalShare).find('input').removeAttr('required');
            }

            $('.content-before', $modalShare).show();
            $('.content-after-pdf', $modalShare).hide();

            // Show the modal window

            $modalShare.modal('open');
        }

        $selectRole.on('change', function() {
            if ($(this).val().length == 32) {
                $('.btn-confirm', $modalShare).removeAttr('disabled').removeClass('disabled');
            } else {
                $('.btn-confirm', $modalShare).prop('disabled', true).addClass('disabled');
            }
        });

        // Send the form
        $('.content-before .btn-confirm', $modalShare).on('click', function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            $('.preloader-wrapper', $modalShare).fadeIn();
            $('.content-before .btn-confirm', $modalShare).addClass('disabled');
            $('.content-before .modal-action', $modalShare).addClass('disabled');

            var form = $('form', $modalShare);
            var ajaxAction = 'dashboard.casting.share';

            var idRole = $("option:selected", $selectRole).val();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: form.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + self.idCasting + "&type=" + type + "&idRole=" + idRole,
            }).done(function(response) {
                $('.preloader-wrapper', $modalShare).hide();
                $('#email', form).removeClass('valid');

                if (response.success) {
                    // Reset the modal window
                    $('.content-before .btn-confirm', $modalShare).removeClass('disabled');
                    $('.content-before .modal-action', $modalShare).removeClass('disabled');
                    $('#email', form).val('');

                    if (type == 'pdf') {
                        // Show a link to download the PDF file
                        var pdfUrl = response.data.file;

                        $('.content-before', $modalShare).hide();
                        $('.content-after-pdf', $modalShare).show();
                        $('#btn-download-pdf', $modalShare).attr('href', pdfUrl);

                    } else if (type == 'print') {
                        $modalShare.modal('close');

                        // Redirect to the page
                        window.location.replace(response.data.redirect);
                    }

                    if (type == 'email') {
                        $modalShare.modal('close');
                        M.toast({html: '<span>'+comedien.i18n.castingMsgShared+'</span>'}, 5000);
                    }
                } else {
                    if (type == 'email') {
                        $('#email', form).addClass('invalid');
                        M.toast({html: '<span>'+comedien.i18n.castingShareInvalidEmail+'</span>'}, 5000);
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }
                }

                $('.content-before .btn-confirm', $modalShare).removeClass('disabled');
                $('.content-before .modal-action', $modalShare).removeClass('disabled');

                self.lockAjaxForm = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
                $modalShare.modal('close');
            });
        });

        // Send an email
        $('.fixed-action-btn .btn-email').on('click', function(e) {
            e.preventDefault();
            type = 'email';
            showModal();
        });

        // Generate a PDF
        $('.fixed-action-btn .btn-pdf').on('click', function(e) {
            e.preventDefault();
            type = 'pdf';
            showModal();
        });

        // Print
        $('.fixed-action-btn .btn-print').on('click', function(e) {
            e.preventDefault();
            type = 'print';
            showModal();
        });
    },

    /**
     * Update the content container/wrapper height.
     */
    updateContainerHeight: function() {
        $('main#content > .col').matchHeight();
        M.updateTextFields();
    },
};

module.exports = new FrontDashboardCastingForm();
